import { createMichelinThemeOptions } from "./createMichelinThemeOptions";

const michelinDarkThemeOptions = createMichelinThemeOptions('dark');

export {
  michelinDarkThemeOptions,
};
